import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ButtonProps,
} from "@chakra-ui/react";
import { FC, useCallback, useRef } from "react";

interface DeleteSchematisationButtonProps extends ButtonProps {
  deleteMultipleFunction: () => void;
  resetSelectedRows?: (rows: []) => void;
  isOpen: boolean;
  onClose: () => void;
}

const RemoveMultipleModal: FC<DeleteSchematisationButtonProps> = ({
  children,
  deleteMultipleFunction,
  resetSelectedRows,
  isOpen,
  onClose,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const onConfirm = useCallback(() => {
    deleteMultipleFunction();
    onClose();
    if (resetSelectedRows) resetSelectedRows([]);
  }, [onClose, deleteMultipleFunction, resetSelectedRows]);

  return (
    <AlertDialog
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      onEsc={onClose}
      onOverlayClick={onClose}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader>Really delete?</AlertDialogHeader>
        <AlertDialogCloseButton />
        <AlertDialogBody>{children}</AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button colorScheme="red" ml={3} onClick={onConfirm}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RemoveMultipleModal;
